import { axios } from '@/utils/request';
const copyProduct = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/copy',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品净值列表
const getNetWorthList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/value/page',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getRateList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/rate/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getManagerList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/investment/manager/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//可分配的投资经理
const getAllManager = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const bindManager = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/add',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//投资经理回显
const managerQueryById = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/manager/page',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品附件
const fileListByCode = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/protocol/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const fileSave = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/protocol/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

const initRateRules = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/value/rule/page',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const saveRateRules = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/value/rule/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品展示列表
const getProductDisplayList = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/getProductShowList',
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    params: params
  });
};
const configureProductDisplay = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/configAppointProductVisibleContent',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const batchConfigureProductDisplay = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/batchConfigProductVisibleContent',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getInvestType = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/getAllProductInvestType',
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getGroupNameList = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getProductGroupName`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const addProductToGroup = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/addProductToAppointProductGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

const getProductListByAppointProductGroup = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getProductListByAppointProductGroup?${params}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//获取未分组的产品列表
const getNotGroupProductList = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getNotGroupProductList${params}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//将产品加入到指定产品分组
const addProductToAppointProductGroup = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/addProductToAppointProductGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品分组列表
const getGroupList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/group/getGroupList',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//风险测评-答题记录详情
const getAnswerList = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT + `/cont/answer/list?recordId=${params}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

//新增分组
const addGroup = params => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/group/addGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//删除分组
const deleteGroup = params => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/group/deleteGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//编辑分组
const editGroup = params => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/group/editGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//获取表头字段
const getAllTableHeadData = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getAllTableHeadData`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品分组-查询某个分组的表头信息
const getTableHeadByGroupId = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/group/getTableHeadByGroupId/${params}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

//提交表头
const addTableHeaderToProductGroup = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/product/show/addTableHeaderToProductGroup',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
//产品分组-根据产品id和分组进行删除
const deleteFundFromGroupByGroupIdAndFundCodes = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      '/content/group/deleteFundFromGroupByGroupIdAndFundCodes',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

const judgeProductIndex = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/judgeProductIndexIsRepeat?fundCode=${params.fundCode}&index=${params.index}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getProductVisibleContent = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getProductVisibleContent?fundCode=${params}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getBatchConfig = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/getProductVisibleContentOfBatchConfig`,
    method: 'get',
    headers: { 'Content-Type': 'application/json; charset=utf-8' }
  });
};
//答题记录
const answerList = params => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + `/cont/record/list`,
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json; charset=utf-8' }
  });
};
const batchConfig = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/batchConfigProductVisibleContent`,
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const batchBindProductToGroup = params => {
  return axios({
    url:
      process.env.VUE_APP_CMS_CONTENT +
      `/content/product/show/batchBindProductToProductGroup`,
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const getSummaryByCode = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + `/product/fund/summary/list`,
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};
const netValueEdit = params => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + `/product/value/save`,
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params
  });
};

export {
  answerList,
  editGroup,
  getTableHeadByGroupId,
  deleteFundFromGroupByGroupIdAndFundCodes,
  addTableHeaderToProductGroup,
  getProductListByAppointProductGroup,
  getNotGroupProductList,
  addProductToAppointProductGroup,
  getAllTableHeadData,
  deleteGroup,
  addGroup,
  getGroupList,
  copyProduct,
  getNetWorthList,
  getRateList,
  getManagerList,
  getAllManager,
  bindManager,
  fileListByCode,
  fileSave,
  managerQueryById,
  initRateRules,
  saveRateRules,
  getProductDisplayList,
  configureProductDisplay,
  batchConfigureProductDisplay,
  getInvestType,
  getGroupNameList,
  addProductToGroup,
  judgeProductIndex,
  getProductVisibleContent,
  getBatchConfig,
  batchConfig,
  batchBindProductToGroup,
  getSummaryByCode,
  netValueEdit,
  getAnswerList
};
